import React from 'react';
import Select from 'react-select';
import FilterModal from '../common/FilterModal';

const TimelineFilterModal = ({
    show,
    onClose,
    onApply,
    onReset,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    managerOptions,
    selectedManager,
    setSelectedManager,
    purposeOptions,
    selectedPurpose,
    setSelectedPurpose
}) => {
    return (
        <FilterModal
            show={show}
            onClose={onClose}
            onApply={onApply}
            onReset={onReset}
        >
            <div className="mb-3">
                <label className="form-label">Date Range</label>
                <div className="d-flex gap-2">
                    <input 
                        type="date" 
                        className="form-control" 
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                    />
                    <input 
                        type="date" 
                        className="form-control" 
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                    />
                </div>
            </div>
            <div className="mb-3">
                <label className="form-label">Sales Manager</label>
                <Select
                    options={managerOptions}
                    value={selectedManager}
                    onChange={setSelectedManager}
                    placeholder="Select Manager"
                    isClearable
                />
            </div>
            <div className="mb-3">
                <label className="form-label">Purpose</label>
                <Select
                    options={purposeOptions}
                    value={selectedPurpose}
                    onChange={setSelectedPurpose}
                    placeholder="Select Purpose"
                    isClearable
                />
            </div>
        </FilterModal>
    );
};

export default TimelineFilterModal;
